<script lang="ts" setup>
const partners = [
  { title: "中国移动", icon: useOssImage("/img/partner/zgyd.png") },
  { title: "中国电信", icon: useOssImage("/img/partner/zgdx.png") },
  { title: "沃尔玛", icon: useOssImage("/img/partner/wem.png") },
  { title: "苏宁易购", icon: useOssImage("/img/partner/snyg.png") },
  { title: "永辉超市", icon: useOssImage("/img/partner/yhcs.png") },
  { title: "中国移动", icon: useOssImage("/img/partner/zgyd.png") },
  { title: "中国联通", icon: useOssImage("/img/partner/zglt.png") },
  { title: "天猫", icon: useOssImage("/img/partner/tm.png") },
  { title: "盒马", icon: useOssImage("/img/partner/hm.png") },
  { title: "京东", icon: useOssImage("/img/partner/jd.jpg") },
  { title: "美团", icon: useOssImage("/img/partner/mt.png") },
  { title: "中国电信", icon: useOssImage("/img/partner/zgdx.png") },
];
</script>
<template>
  <div class="partners-panel">
    <el-carousel
      indicator-position="outside"
      arrow="never"
      height="184px"
      class="partners-carousel"
    >
      <el-carousel-item v-for="(item, index) in 4" :key="index">
        <div class="partners-grid">
          <div
            class="partner-item"
            v-for="(item, index) in partners"
            :key="index"
          >
            <img :src="item.icon" :alt="item.title" />
            <span class="partner-name">{{ item.title }}</span>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<style lang="scss" scoped>
.partners-panel {
  width: 100%;
}

.partners-carousel {
  :deep(.el-carousel__container) {
    height: 186px;
  }

  :deep(.el-carousel__indicators--outside) {
    margin-top: 10px;
  }

  :deep(.el-carousel__button) {
    width: 9px;
    height: 9px;
    border-radius: 999px;
    background: #b7c3cf;
    opacity: 1;
  }

  :deep(.el-carousel__indicator.is-active .el-carousel__button) {
    width: 38px;
    height: 8px;
    background: #FF7A3C;
  }
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px 15px;
  padding: 0;

  .partner-item {
    background: #fff;
    border: 1px solid #d9dfe7;
    border-radius: 4px;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 18px;
    box-shadow: none;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    img {
      max-height: 48px;
      max-width: 122px;
      object-fit: contain;
      flex-shrink: 0;
    }

    .partner-name {
      display: inline-flex;
      align-items: center;
      min-width: 0;
      color: #1d3550;
      font-size: 17px;
      font-weight: 700;
      line-height: 1.15;
      white-space: nowrap;
    }

    &:hover {
      border-color: #b8d8ff;
      box-shadow: 0 6px 16px rgba(64, 158, 255, 0.08);
    }
  }
}

@media (max-width: 900px) {
  .partners-carousel {
    :deep(.el-carousel__container) {
      height: 588px;
    }
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .partners-carousel {
    :deep(.el-carousel__container) {
      height: 492px;
    }
  }

  .partners-grid {
    gap: 14px;

    .partner-item {
      height: 66px;
      padding: 8px 12px;

      img {
        max-width: 72px;
        max-height: 38px;
      }

      .partner-name {
        font-size: 14px;
      }
    }
  }
}
</style>
